import styled, { css } from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Link, { A } from 'components/common/Link/Link'

export const Block = styled.div`
  ${Media.desktop`
    display: inline-block;
    vertical-align: top;
  `}
  ${Mixin.responsive('margin-top', '30px', '20px')}
`

export const Cell = styled.div`
  ${Media.desktop`
    display: inline-block;
    float: right;
    width: 165px;
    padding-left: 20px;
    vertical-align: top;
  `}
  ${Mixin.responsive('text-align', 'right', 'left')}
  ${Mixin.responsive('margin-top', '30px', '11px')}
`

export const Text = styled.span`
  color: ${Theme.colors.sub_grey};
  ${Mixin.responsive('line-height', '22px', '19px')}
  ${props => props.margin && css`
    margin-right: 4px;
  `}
  ${props => props.bold && css`
    font-weight: 600;
  `}
`

export const PhoneLink = styled(Link)`
  ${Media.mobile`
    display: block;
  `}
`

export const CallStore = styled.span`
  font-weight: 600;
  line-height: 22px;
`

export const StoreLink = styled(A)`
  display: inline-block;
  ${Mixin.responsive('line-height', '22px', '19px')}
  ${Mixin.responsive('margin-top', '30px', '5px')}
`
